export default __webpack_public_path__ + "061ad3da626fd91dc06f5a464220a6e7.jpg";